import { render, staticRenderFns } from "./ConfirmInfoSection.vue?vue&type=template&id=c8fbdd50&scoped=true"
import script from "./ConfirmInfoSection.vue?vue&type=script&lang=ts"
export * from "./ConfirmInfoSection.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmInfoSection.vue?vue&type=style&index=0&id=c8fbdd50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fbdd50",
  null
  
)

export default component.exports